import _defer from 'lodash/defer';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './styles.less';

const DROP_DISTANCE = 7;
const DISTANCE_FROM_EDGE = 5;
const SHOW_CLASS = 'show';

const propTypes = {
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  closeHandler: PropTypes.func,
  vAlign: PropTypes.oneOf(['auto', 'top', 'bottom']),
};

const DropdownMenu = class extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { position_rerender: false };

    this.onTransitionEnd = this.onTransitionEnd.bind(this);
  }

  render() {
    const { children, show } = this.props;
    const positionStyles = this.getPositionStyles();
    const showClass = show ? SHOW_CLASS : '';

    const { additionalClass = '' } = this.props;

    return (
      <div
        className={`dropdown-menu ${showClass} ${additionalClass}`}
        ref={me => (this.menu = me)}
        onTransitionEnd={this.onTransitionEnd}
        style={positionStyles}
      >
        {children}
      </div>
    );
  }

  componentDidMount() {
    // in order to get a proper hidden position, re-render
    this.setState({ position_rerender: true });
  }

  onTransitionEnd() {
    const { onClose, onOpen, show } = this.props;

    // wait until state is changed AND defer to allow time for DOM to reflect
    // changes
    if (show && onOpen) {
      _defer(onOpen);
    } else if (!show && onClose) {
      _defer(onClose);
    }
  }

  getPositionStyles() {
    if (!this.menu) {
      return;
    }

    const { align, show } = this.props;

    let vAlign = this.props.vAlign;

    const style = {};

    const parent = this.menu.parentNode;
    const parentSize = parent.getBoundingClientRect();
    const rightEdge =
      parentSize.right - (this.menu.clientWidth + DISTANCE_FROM_EDGE);
    const leftEdge =
      document.body.offsetWidth -
      parentSize.left -
      (this.menu.clientWidth + DISTANCE_FROM_EDGE);
    const center = -(this.menu.clientWidth / 2 - parent.clientWidth / 2);

    // make sure the menu is positioned appropriately and does not go off screen to the right or left
    switch (align) {
      case 'right':
        style.right = Math.min(0, rightEdge);
        break;
      case 'center':
        style.left = Math.min(center, leftEdge);
        break;
      case 'left':
      default:
        style.left = Math.min(0, leftEdge);
        break;
    }

    const viewportHeight = document.body.clientHeight;
    const parentVerticalCenter = parentSize.top + parentSize.height / 2;
    const mostSpaceAbove = parentVerticalCenter > viewportHeight / 2;

    if (vAlign === 'auto') {
      vAlign = mostSpaceAbove ? 'bottom' : top;
    }

    // valign=top: Slide down when showing and slide back up when hiding
    // valign=bot: Slide up when showing and slide back down when hiding
    const dropDirection = vAlign === 'top' ? 1 : -1;
    const marginToOriginBox = 4;
    const dropDistance =
      dropDirection * ((show ? DROP_DISTANCE : -DROP_DISTANCE) - DROP_DISTANCE);

    switch (vAlign) {
      default:
      case 'top':
        style.top = parent.clientHeight + dropDistance + marginToOriginBox;
        break;
      case 'bottom':
        style.top = -this.menu.clientHeight + dropDistance - marginToOriginBox;
        break;
    }

    // Avoid overflowing to the left (x < 0)
    if (style.left != null) {
      // Calculate where menu would be without our modifications
      const originalLeft =
        this.menu.getBoundingClientRect().left -
        parseInt(this.menu.style.left, 10);
      const futureLeft = originalLeft + style.left;

      if (futureLeft < 0) {
        style.left += Math.abs(futureLeft);
      }
    }

    return style;
  }
};

DropdownMenu.propTypes = propTypes;

export default DropdownMenu;
